import { render, staticRenderFns } from "./AdminAddAdditionalItemDialog.vue?vue&type=template&id=6c1d8c30"
import script from "./AdminAddAdditionalItemDialog.vue?vue&type=script&lang=js"
export * from "./AdminAddAdditionalItemDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminAddAdditionalItemDialog.vue?vue&type=style&index=0&id=6c1d8c30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports